"use client";

import React from "react";
import { ComponentConfig } from "@puckeditor/core";
import { businessData } from "@/data/business";

export interface TestimonialItem {
  quote: string;
  name: string;
  role: string;
  initials: string;
}

export interface TestimonialsProps {
  heading?: string;
  testimonials?: TestimonialItem[];
}

export const TestimonialsBlock: ComponentConfig<TestimonialsProps> = {
  label: "Testimonials Section",
  fields: {
    heading: { type: "text", label: "Section Heading" },
    testimonials: {
      type: "array",
      getItemSummary: (t: any) => t.name || "Testimonial",
      arrayFields: {
        quote: { type: "textarea", label: "Quote Content" },
        name: { type: "text", label: "Author Name" },
        role: { type: "text", label: "Author Role & Brand" },
        initials: { type: "text", label: "Initials for Avatar" },
      },
      defaultItemProps: {
        quote: "Add an approved client quotation. Do not publish testimonials without written permission.",
        name: "Client name",
        role: "Role and brand",
        initials: "CN",
      },
    },
  },
  defaultProps: {
    heading: "Trusted by Derma & Beauty Founders",
    testimonials: businessData.testimonials,
  },
  render: ({ heading, testimonials }) => {
    const list = testimonials || [];

    if (list.length === 0) return <></>;

    return (
      <section className="sec" id="testimonials">
        <div className="container">
          <div className="sec-head">
            <h2>{heading}</h2>
          </div>
          <div className="quotes">
            {list.map((item, idx) => (
              <figure className="quote" data-animate key={idx}>
                <blockquote>“{item.quote}”</blockquote>
                <div className="quote-author">
                  <div className="quote-avatar">{item.initials}</div>
                  <figcaption>
                    <strong>{item.name}</strong>
                    <span>{item.role}</span>
                  </figcaption>
                </div>
              </figure>
            ))}
          </div>
        </div>
      </section>
    );
  },
};
